import React from "react";
import { NavLink } from "react-router-dom";

import logoImg from "../assets/dogs_n_cats.png";
import "../css/Sidebar.css";

import DashboardIcon from "../assets/Icons/DashboardIcon";
import CusomerIcon from "../assets/Icons/CustomerIcon";
import DoctorIcon from "../assets/Icons/DoctorIcon";
import ServiceIcon from "../assets/Icons/ServiceIcon";
import AppointmentIcon from "../assets/Icons/AppointmentIcon";
import SubscriptionIcon from "../assets/Icons/SubscriptionIcon";
import BookingIcon from "../assets/Icons/BookingIcon";
import ProductIcon from "../assets/Icons/ProductIcon";
import ShopIcon from "../assets/Icons/ShopIcon";
import SettingsIcon from "../assets/Icons/SettingsIcon";

const Sidebar = () => {
  const navItems = [
    { path: "/Dashboard", label: "Dashboard", icon: <DashboardIcon /> },
    { path: "/customer", label: "Customer", icon: <CusomerIcon /> },
    { path: "/doctors", label: "Doctors", icon: <DoctorIcon /> },
    { path: "/pet-services", label: "Service", icon: <ServiceIcon /> },
    { path: "/Appointment", label: "Appointments", icon: <AppointmentIcon /> },
    {
      path: "/shoppers-and-shop",
      label: "Shoppers and Shop",
      icon: <ShopIcon />,
    },
    {
      path: "/subscription-plan",
      label: "Subscription Plan",
      icon: <SubscriptionIcon />,
    },
    
    { path: "/booking", label: "Booking", icon: <BookingIcon /> },

    {
      path: "/profile-settings",
      label: "Profile Settings",
      icon: <SettingsIcon />,
    },
  ];

  return (
    <aside className="sidebar">
      <div className="logo-section">
        <img src={logoImg} alt="Pawfriends" className="logo" />
        <h2>Pawfriends</h2>
      </div>

      <nav className="menu">
        {navItems.map(({ path, label, icon }) => (
          <NavLink
            key={path}
            to={path}
            end={path === "/"}
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <span className="sidebar-icon">{icon}</span>
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
